/**
 * Send an emoji message via the existing game event pipeline.
 *
 * Validates emojiId, checks cooldown, then submits through room API.
 * Starts cooldown timer after successful send.
 */

import type { GameApi } from "../services/game-api";
import { emojiMessageActions } from "./emoji-message-store";
import { EMOJI_MESSAGE_EVENT_TYPE, type EmojiId } from "./types";
import { validateEmojiId } from "./validate-emoji";

export async function sendEmojiMessage(
  gameApi: GameApi,
  roomId: string,
  emojiId: EmojiId,
  displayName: string,
): Promise<boolean> {
  const validation = validateEmojiId(emojiId);
  if (!validation.valid) {
    return false;
  }

  try {
    await gameApi.submitEvent(roomId, EMOJI_MESSAGE_EVENT_TYPE, {
      emojiId,
      displayName,
    });
    emojiMessageActions.startCooldown();
    return true;
  } catch (error) {
    console.error("[emoji-message] send failed:", error);
    return false;
  }
}
